export var AuthMode;
(function (AuthMode) {
    AuthMode[AuthMode["view"] = 0] = "view";
    AuthMode[AuthMode["edit"] = 1] = "edit";
})(AuthMode || (AuthMode = {}));
//# sourceMappingURL=AuthMode.js.map